import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/map';

import {ConstantService} from '../../constant/constant.service';

/**
 * Description of Notification Service
 *
 * @author Hirpara Ravi
 */

@Injectable({
  providedIn: 'root'
})   
export class NotificationService {

  constructor(
    private constantService: ConstantService,
    private http: HttpClient
  ) {
  }

  private _items: any = {};
  
  setItem(item: any) {
    this._items = item;
  }

  getItems() {
    return this._items;
  }

  schedule() {
    let params : any = { type : 1 };
    return this.http.get(this.constantService.getUrl(`${this.constantService.NOTIFICATION}/schedule`), {
      params: params
    });
  }

}